import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import * as styles from './styles';
import { ExpiredViewProps } from './models';
import { Slogan } from '~/components/app/components/landingPage/components/slogan/Slogan';
import { useTranslation } from '@sunbit-dev/translations';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';
import { PagesTestIds } from '~/enums/TestIds';
import { PrivacyAllowanceLayer } from '@sunbit-dev/purchase-common/src/components/privacyAllowanceLayer/PrivacyAllowanceLayer';
import { TrackCategory } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import messageService from '~/services/MessageService';
import { LoanApplicationOrigin } from '~/enums/LoanApplicationOrigin';
import { getApplicationLocalStorageValue } from '~/helpers/utils';
import { ApplicationLocalStorageKey } from '~/enums/ApplicationLocalStorageKey';
import Verticals from '@sunbit-dev/common/enums/Verticals';

export const ExpiredLinkPage = styled(({ className }: ExpiredViewProps) => {
  const { t } = useTranslation('link_expired');
  const { track } = useTrack();

  const isCheckoutPlatformVertical = useMemo(
    () => getApplicationLocalStorageValue(ApplicationLocalStorageKey.MERCHANT_VERTICAL) === Verticals.Checkout_Platform,
    []
  );
  const isOnlineSdkOrigin = useMemo(
    () =>
      getApplicationLocalStorageValue(ApplicationLocalStorageKey.LOAN_APPLICATION_ORIGIN) ===
      LoanApplicationOrigin.ONLINE_SDK,
    []
  );
  const isPlatformApplication = useMemo(() => isCheckoutPlatformVertical || isOnlineSdkOrigin, []);

  useEffect(() => {
    track({ eventName: EventsNames.expiredLink, type: TrackCategory.View });
  }, []);

  useEffect(() => {
    if (isOnlineSdkOrigin) {
      const cancelTimer = setTimeout(() => messageService.messageCancel(), 5000);
      return () => clearTimeout(cancelTimer);
    }
  }, [isOnlineSdkOrigin]);

  return (
    <div className={className} data-testid={PagesTestIds.ExpiredView}>
      <PrivacyAllowanceLayer>
        {!isPlatformApplication && <Slogan className="slogan" />}
        <div className="description">
          <h1 className="title">{t(isPlatformApplication ? 'platform_title' : 'title')}</h1>
          <p className="subtitle">{t(isPlatformApplication ? 'platform_subtitle' : 'subtitle')}</p>
        </div>
        {isPlatformApplication && <Slogan className="slogan" />}
      </PrivacyAllowanceLayer>
    </div>
  );
})`
  ${styles.ExpiredView}
`;
